import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-16 bg-white border-b border-solid border-brand-gray-1"
}
const _hoisted_2 = { class: "flex items-center h-full px-8" }
const _hoisted_3 = { "data-test": "job-count" }
const _hoisted_4 = { class: "text-brand-green-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.onJobResultsPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              class: "mr-3 text-gray-600 text-base",
              icon: ['fas', 'search']
            }),
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.FILTERED_JOBS.length), 1),
              _createTextVNode(" jobs matched ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}